export const TOKEN_KEY = 'auth_token';
export const REFRESH_TOKEN_KEY = 'auth_refresh_token';

export const API_URL =
  window._env_?.REACT_APP_API_URL || process.env.REACT_APP_API_URL;

export const ONBOARDING_URL =
  window._env_?.REACT_APP_ONBOARDING_API_URL ||
  process.env.REACT_APP_ONBOARDING_API_URL;

export const ONBOARDING_GRAVITEE_KEY =
  window._env_?.REACT_APP_ONBOARDING_GRAVITEE_KEY ||
  process.env.REACT_APP_ONBOARDING_GRAVITEE_KEY;

export const ONBOARDING_AUTH_GRAVITEE_KEY =
  window._env_?.REACT_APP_ONBOARDING_AUTHORIZATION_API_KEY ||
  process.env.REACT_APP_ONBOARDING_AUTHORIZATION_API_KEY;

export const CERTIFICATION_GRAVITEE_KEY =
  window._env_?.REACT_APP_CERTIFICATION_GRAVITEE_KEY ||
  process.env.REACT_APP_CERTIFICATION_GRAVITEE_KEY;

export const SME_URL =
  window._env_?.REACT_APP_SME_URL || process.env.REACT_APP_SME_URL;

export const SME_GRAVITEE_KEY =
  window._env_?.REACT_APP_SME_GRAVITEE_KEY ||
  process.env.REACT_APP_SME_GRAVITEE_KEY;

export const SHOW_SME =
  window._env_?.REACT_APP_SHOW_SME || process.env.REACT_APP_SHOW_SME;

export const TAX_RETURN_URL =
  window._env_?.REACT_APP_TAX_RETURN_URL ||
  process.env.REACT_APP_TAX_RETURN_URL;

export const PRINT_URL =
  window._env_?.REACT_APP_PRINT_URL || process.env.REACT_APP_PRINT_URL;

export const OTP_URL =
  window._env_?.REACT_APP_OTP_URL || process.env.REACT_APP_OTP_URL;

export const OTP_GRAVITEE_KEY =
  window._env_?.REACT_APP_OTP_GRAVITEE_KEY ||
  process.env.REACT_APP_OTP_GRAVITEE_KEY;

export const STATISTICS_API_URL =
  window._env_?.REACT_APP_STATISTICS_API_URL ||
  process.env.REACT_APP_STATISTICS_API_URL;

export const STATISTICS_GRAVITEE_KEY =
  window._env_?.REACT_APP_STATISTICS_GRAVITEE_KEY ||
  process.env.REACT_APP_STATISTICS_GRAVITEE_KEY;

export const ENVIRONEMNT =
  window._env_?.REACT_APP_ENV || process.env.REACT_APP_ENV;

export const TAX_COUNTRY =
  window._env_?.REACT_APP_TAX_COUNTRY || process.env.REACT_APP_TAX_COUNTRY;

export const AUTH_URL =
  window._env_?.REACT_APP_AUTH_URL || process.env.REACT_APP_AUTH_URL;

export const AUTH_URL_TOKEN =
  window._env_?.REACT_APP_AUTH_URL_TOKEN ||
  process.env.REACT_APP_AUTH_URL_TOKEN;

export const AUTH_LOGIN_URL =
  window._env_?.REACT_APP_AUTH_LOGIN_URL ||
  process.env.REACT_APP_AUTH_LOGIN_URL;

export const AUTH_CALLBACK_URL =
  window._env_?.REACT_APP_AUTH_CALLBACK_URL ||
  process.env.REACT_APP_AUTH_CALLBACK_URL;

export const AUTH_POC_URL =
  window._env_?.REACT_APP_AUTH_POC_URL || process.env.REACT_APP_AUTH_POC_URL;

export const AUTH_REFRESH_URL =
  window._env_?.REACT_APP_AUTH_REFRESH_URL ||
  process.env.REACT_APP_AUTH_REFRESH_URL;

export const VGRP_BLOCKED_ROLES = window._env_?.REACT_APP_VGRP_BLOCKED_ROLES ??
  process.env.REACT_APP_VGRP_BLOCKED_ROLES?.split(' ') ?? ['onboarding'];

export const IS_POC = false;

export const THEMES = {
  NBR: {
    header: '#FFF',
    footer: '#2B373C',
    primary: '#547D84',
    secondary: '#39555A',
    gray: '#F0F0F0',
    background: '#FAF9F9',
  },
  eiv: {
    header: '#000',
    footer: '#000',
    primary: '#26890D',
    secondary: '#42982c',
    gray: '#F0F0F0',
    background: '#FAF9F9',
  },
};
export const SELECT_AN_OPTION_LABEL = 'Select an option';

export const ENABLE_MOCKS = false;

export const WHITELISTED_ROUTES = ['activate-point-of-contact'];
